<script setup lang="ts">
defineOptions({
  name: 'ProzesseComponent'
})

const { elementReference, isReady, isRevealed } = useScrollReveal()
</script>

<template>
  <div
    ref="elementReference"
    :class="['px-0 py-0 mx-0 my-0', { reveal: isReady, revealed: isRevealed }]"
  >
    <div class="pt-high">
      <v-row align="center">
        <v-col cols="12" lg="6" class="pb-8 pb-lg-0">
          <NuxtImg
            class="w-100"
            src="/images/Einstellung.jpg"
            alt="Prozesse"
            cover
            loading="lazy"
          />
        </v-col>
        <v-col cols="12" lg="6" class="px-8 px-lg-16">
          <h3 class="text-primary bannerTitle font-weight-regular mb-8">Einstellung</h3>
          <p class="text-body-1 mb-4">
            Die Kunst der Architektur besteht für uns nicht nur darin beeindruckende Strukturen zu
            entwerfen, sondern auch darin eine nahtlose Verbindung in die Realität herzustellen.
            Durch unsere fundierte Beratung sind wir in der Lage, Ihr Projekt nicht nur zu betreuen
            und zu managen, sondern es mit einem Auge für Detail und Ästhetik zu durchdringen.
          </p>
          <p class="text-body-1 mb-4">
            Unsere Expertise erstreckt sich über die kostengünstigen Entwürfe, die produktoffene
            Bauweise bis hin zu hochwertigen Ausstattungen, die speziell auf Ihre Bedürfnisse
            zugeschnitten sind. Wir sind stolz darauf, ein breites Themenspektrum abzudecken – von
            einfachen Gewerbe-/Hallenbau bis hin zu anspruchsvollen Verwaltungsgebäuden oder
            Geschosswohnungsbauten.
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
